import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {ApiwrapperService} from "../../services/apiwrapper.service";
import {DataManipulationService} from "../../services/data-manipulation.service";
import {forkJoin, map, Observable, Subscription, switchMap, tap} from "rxjs";
import {ModalsComponent} from "../modals/modals.component";
import {AuthGuard} from "../../helpers/auth.guard";
import {AuthenticationService} from "../../services/authentication.service";
import {Router, Event, NavigationStart} from "@angular/router";
import { CreateProjectTeamModalService } from 'src/app/services/create-project-team-modal.service';
import { CreatNewProjectTeamModalComponent } from '../creat-new-project-team-modal/creat-new-project-team-modal.component';

interface HomeMenuConfig {
  show: boolean,
  route: string
}

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnDestroy {
  gotTeams: boolean = false;
  teams: any = [];
  showTeamsOverview: boolean = true;
  private prioritySubscription: Subscription;
  myTeams: any[] = [];
  otherTeams: any[] = [];
  workspacePlanFree: boolean = false;
  notMember: boolean = false;
  memberPrio: any = {};
  isTeamDropdownOpen = false;
  isProjectTeamsDropdownOpen = false;
  isAddDropdownOpen = false;
  isSettingsDropdownOpen = false;
  isMyTeamsDropdownOpen: boolean = false;
  isOtherTeamsDropdownOpen: boolean = false;
  isMyProjectsDropdownOpen: boolean = false;
  isOtherProjectsDropdownOpen: boolean = false;
  showActionButton: boolean = false;
  showFeedbackTemplatesButton: boolean = false;
  onMyPlanPage: boolean = false;
  myPlanAddon!: Observable<any>;
  projectTeamAddon!: Observable<any>;
  userPermissions: any;
  workspaceProjects: any;
  currentUserHaveViews: boolean = false;

  homeMenuConfig: HomeMenuConfig = {
    show: false,
    route: '/',
  };

  private readonly OWNER_PRIORITY = 40;
  private readonly ADMIN_PRIORITY = 30;
  private readonly HR_PRIORITY = 20;

  private readonly TEAM_LEADER_PRIORITY = 20;
  private readonly TEAM_MEMBER_PRIORITY = 10;

  constructor(private apiwrapper: ApiwrapperService, public data: DataManipulationService, public modal: ModalsComponent,
              public auth: AuthenticationService, private cdRef: ChangeDetectorRef, private router: Router, private createTeamProjectModalService: CreateProjectTeamModalService) {
    let interv = setInterval(() => {
      if (document.getElementById('header-toggle') !== null && document.getElementById('navbar') !== null) {
        this.showMenu('header-toggle', 'navbar');
        clearInterval(interv);
      }
    }, 500);
    this.onMyPlanPage = router.url === '/my-plan' ? true : false;
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.onMyPlanPage = event.url.includes('/my-plan') ? true : false;
      }
    });
    this.prioritySubscription = this.data.userPriorities
      .subscribe((value: any) => {
        // this.gotPriority = true;
        this.data.userRole = value;
        this.memberPrio = value;
        this.setTeams();
        this.filterTeamsTree();
        this.setHomeMenuConfig();
      });

    if (this.data.getWorkspacePlan().requirePayment === 'no') {
      this.workspacePlanFree = true;
    }
  }


  ngOnInit(): void {
    this.getPermissions();
    this.getAddons();
    this.getWorkspaceProjectTeams();
    this.getUserViews();
    // check if user is members
    this.setTeams();
    this.filterTeamsTree();
  }

  ngOnDestroy() {
    if (!localStorage.getItem('ONBOARDING')) {
      this.prioritySubscription.unsubscribe();
    }
  }

  getAddons() {
    this.myPlanAddon = this.data.myPlanAddon$;
    this.projectTeamAddon = this.data.projectTeamAddon$;
  }

  getPermissions() {
    this.data.getUserProjectPermissions.subscribe((permissions: any) => {
      this.userPermissions = permissions;
    });
  }

  getWorkspaceProjectTeams() {
    //@ts-ignore
    const user = JSON.parse(localStorage.getItem('userDetails'));
    this.data.getAllWorkspaceProjects().pipe(
      switchMap(projects =>
        forkJoin(
          projects.map((project: any) =>
            this.apiwrapper.getProjectTeamMembers(project.uuid).pipe(
              map((res: any) => res._embedded.users ?? []),
              map(members => ({
                project,
                isMyProject: members.some((member: any) => member.user.uuid === user.uuid
                )
              }))
            )
          )
        )
      ),
      map((results: any) => ({
        myProjects: results
          .filter((result: any) => result.isMyProject)
          .map((result: any) => result.project),

        otherProjects: results
          .filter((result: any) => !result.isMyProject)
          .map((result: any) => result.project)
      }))
    ).subscribe((res: any) => {
      this.workspaceProjects = res;
    });
  }

  getUserViews() {
    this.apiwrapper.getTeamsOverviewViews().pipe(
      map((res: any) => res._embedded.views ?? []),
      tap((res: any) => {
        this.currentUserHaveViews = !!res.length;
      })
    ).subscribe();
  }

  showMenu(headerToggle: string, navbarId: string) {
    // Validate that variables exist
    if (headerToggle && navbarId) {
      if (document.getElementById(headerToggle) !== null) {
        // @ts-ignore
        document.getElementById(headerToggle).addEventListener('click', () => {
          // We add the show-menu class to the div tag with the nav__menu class
          // @ts-ignore
          document.getElementById(navbarId).classList.toggle('show-menu')
          // change icon
          // @ts-ignore
          document.getElementById(headerToggle).classList.toggle('bx-x')
        })
      }
    }
  }

  closeMenu() {
    //@ts-ignore
    document.getElementById('navbar').classList.toggle('show-menu');
  }

  setTeams() {
    this.showActionButton = false;
    this.memberPrio = {...this.data.userRole};
    if (this.memberPrio.role.workspacePriority > 20) {
      this.notMember = true;
    } else if (this.memberPrio.role.workspacePriority <= 20) {
      this.notMember = false;
    }
    // set teams in menu
    this.teams = [...this.data.userTeams()];
    // set menu actions button if user is team-leader
    if (this.teams.length > 0) {
      this.teams.forEach((el: any) => {
        if (el.myRole !== null) {
          if (el.myRole.teamPriority > 10) {
            this.showActionButton = true;
            this.showFeedbackTemplatesButton = true;
          }
        }
      });
    }
  }

  filterTeamsTree() {
    if (this.teams.length > 0 && this.memberPrio.role.workspacePriority > 20) {
      this.myTeams = this.teams.filter((team: any) => team.myRole);
      this.otherTeams = this.teams.filter((team: any) => !team.myRole);
    }
  }

  logout() {
    this.auth.logout();
    location.reload();
  }

  retrieveMenuItems() {
    this.isTeamDropdownOpen ? this.isTeamDropdownOpen = !this.isTeamDropdownOpen : this.isTeamDropdownOpen;
    this.isAddDropdownOpen ? this.isAddDropdownOpen = !this.isAddDropdownOpen : this.isAddDropdownOpen;
    this.isSettingsDropdownOpen ? this.isSettingsDropdownOpen = !this.isSettingsDropdownOpen : this.isSettingsDropdownOpen;
    this.isProjectTeamsDropdownOpen ? this.isProjectTeamsDropdownOpen = !this.isProjectTeamsDropdownOpen : this.isProjectTeamsDropdownOpen;
    this.isMyTeamsDropdownOpen ? this.isMyTeamsDropdownOpen = !this.isMyTeamsDropdownOpen : this.isMyTeamsDropdownOpen;
    this.isOtherTeamsDropdownOpen ? this.isOtherTeamsDropdownOpen = !this.isOtherTeamsDropdownOpen : this.isOtherTeamsDropdownOpen;
    this.isMyProjectsDropdownOpen ? this.isMyProjectsDropdownOpen = !this.isMyProjectsDropdownOpen : this.isMyProjectsDropdownOpen;
    this.isOtherProjectsDropdownOpen ? this.isOtherProjectsDropdownOpen = !this.isOtherProjectsDropdownOpen : this.isOtherProjectsDropdownOpen;
  }

  goToBilling() {
    this.data.lastRouteBeforeBilling = this.router.url;
  }

  async openProjectTeamsModal() {
    const results$ = this.createTeamProjectModalService.openModal({
      component: CreatNewProjectTeamModalComponent,
      inputs: {modalStep: 1}
    });

    results$.subscribe((data: any) => {

    })
  }

  private setHomeMenuConfig(): void {
    const workspacePriority = this.memberPrio?.role?.workspacePriority;
    const startGuide = this.memberPrio?.workspace?.startGuide === true;

    const isWorkspaceOwnerOrAdmin =
      workspacePriority === this.OWNER_PRIORITY ||
      workspacePriority === this.ADMIN_PRIORITY;

    const isWorkspaceHr =
      workspacePriority === this.HR_PRIORITY;

    const isLeaderInAnyTeam = this.data.userRole.teams.some((item: any) => item.role?.teamPriority === this.TEAM_LEADER_PRIORITY);

    const isMemberInAnyTeam = this.data.userRole.teams.some(
      (item: any) => item.role?.teamPriority === this.TEAM_MEMBER_PRIORITY
    );

    if (isWorkspaceHr) {
      this.homeMenuConfig = this.data.userRole.teams.length >= 2
        ? {
            show: true,
            route: '/teams-overview',
          }
        : {
            show: false,
            route: '/',
          };

      return;
    }

    if (isWorkspaceOwnerOrAdmin && startGuide) {
      this.homeMenuConfig = {
        show: true,
        route: '/workspace-overview',
      };

      return;
    }

    if (!startGuide && isLeaderInAnyTeam) {
      this.homeMenuConfig = {
        show: true,
        route: '/workspace-member-leader',
      };

      return;
    }

    if (!startGuide && isMemberInAnyTeam) {
      this.homeMenuConfig = {
        show: true,
        route: '/workspace-member',
      };

      return;
    }

    this.homeMenuConfig = {
      show: false,
      route: '/',
    };
  }
}
